<template>
  <div class="main">
    <div class="title-bar">
      <h1 class="mb-0">Online Session Logs</h1>
      <a class="btn-back" :href="route('admin.logs.sessions.index')">
        <span class="icon icon-arrow-left"></span>
        <span class="text">Back to List</span>
      </a>
    </div>
    <div class="content p-3">
      <div class="row">
        <div class="col-12">
          <div class="row">
            <div class="col-12">
              <ListTable
                :items="items"
                :columns="columns"
                :activeColumns="activeColumns"
                :hideHeaderMenus="true"
              >
                <template v-slot:col_created_at="{ item }"
                  >{{
                    item.created_at | moment("M/D/YYYY h:mma")
                  }}
                  EST</template
                >
              </ListTable>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ListTable from "components/listings/Table";
export default {
  components: { ListTable },
  props: {
    columns: { type: Array, required: true },
    items: { type: Array, required: true },
  },
  computed: {
    activeColumns() {
      return this.columns.map((column) => {
        return column.key;
      });
    },
  },
};
</script>
